import { Service } from 'types';
import { createSelectField } from './createSelectField';

export const ServiceSelectField = createSelectField<Service>('advert/services/', {
  getOptionLabel: ({ title }: Service) => title,
  getOptionValue: ({ id }: Service) => id.toString(),
});
